<nb-card>
  <nb-card-header>
    <div class="form-inline">
      <nb-form-field fullWidth>
        <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
        <input
          type="text"
          nbInput
          fullWidth
          shape="semi-round"
          class="form-control"
          placeholder="{{ 'common.strSearch' | translate }}"
          [(ngModel)]="strSearch"
        />
      </nb-form-field>

      <button
        type="submit"
        nbButton
        outline
        shape="semi-round"
        status="primary"
        size="small"
        (click)="create()"
        [disabled]="loading"
        [class.btn-pulse]="loading"
      >
        {{ "buttons.create" | translate }}
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <nb-list>
      <nb-list-item
        *ngFor="let item of displays | filter: strSearch; let i = index"
        [ngClass]="i % 2 == 0 ? 'content bg1' : 'content bg2'"
      >
        <div>
          <h6 class="text-primary">{{ item.title }}</h6>
        </div>
        <button
          nbButton
          shape="round"
          outline
          status="success"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="selected(item)"
        >
          <nb-icon icon="checkmark-outline"></nb-icon>
        </button>
      </nb-list-item>
    </nb-list>
  </nb-card-body>

  <nb-card-footer *ngIf="linkCatalogId != ''">
    <button
      nbButton
      shape="round"
      outline
      status="danger"
      size="small"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
      (click)="removeLink()"
    >
      <nb-icon icon="trash-2-outline"></nb-icon>
      <span>Bỏ chọn</span>
    </button>
  </nb-card-footer>
</nb-card>
